import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import CustomCheckbox from './Form/CustomCheckbox';

export interface ConfirmationProps {
    title: string;
    children?: React.ReactElement;
    open: boolean;
    setOpen?: (open: boolean) => void;
    onConfirm: (dontShowAgain?: boolean) => void;
    onCancel?: () => void;
    onClose?: () => void;
    showDontShowAgain?: boolean;
    confirmText?:string;
    hideCancelButton?:boolean;
}


const CustomConfirmDialog: React.FC<ConfirmationProps> = (props) => {
    const { title, children, open, setOpen, onConfirm ,onCancel, onClose, showDontShowAgain,confirmText,hideCancelButton} = props;
    const [dontShowAgainSelected,setDontShowAgainSelected] = useState(false);
    
    return (
        <Dialog open={open} onClose={() => {
        setOpen && setOpen(false);
        onClose && onClose();
        }
        } aria-labelledby="confirm-dialog">
           {title && <DialogTitle id="confirm-dialog"><FormattedMessage id={title} /></DialogTitle>}
            <DialogContent>{children}</DialogContent>
            <DialogActions sx={{px:3, 
                justifyContent: showDontShowAgain ? 'space-between' : 'flex-end',
                gap: 2}}>
                {showDontShowAgain && 
                <Box
            sx={{
                minWidth: 0,
                maxWidth: '40%'
            }}
        >
                <CustomCheckbox label="Don't show this message again" onChange={(cheked:boolean)=>{
                    setDontShowAgainSelected(cheked)
                }} /></Box>}
                <Box>
                  
                {hideCancelButton != true && <Button variant="outlined" sx={{mr:1}} onClick={() => {
                   // console.log('cancel clicked')
                    setOpen && setOpen(false);
                    onCancel && onCancel();
                }
                    } color="primary">
                    <FormattedMessage id="no" />
                </Button>}
                <Button
                    variant="contained"
                    onClick={() => {
                        
                        setOpen && setOpen(false);
                        onConfirm(showDontShowAgain ? dontShowAgainSelected : undefined);
                        onClose && onClose();
                    }}
                    color="primary"
                >
                    <FormattedMessage id={confirmText || 'yes'} />
                    
                </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};
export default CustomConfirmDialog;
